import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Button,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardBillingBLInterfaceUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardBillingBLInterfaceUX-div-0"
        style={{width: "calc(-180px + 100vw)", height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardBillingBLInterfaceUX-div-1"
          style={{padding: "10px 5px 15px", marginBottom: "-10px"}}>
          
          <FormGroup
            id="CardBillingBLInterfaceUX-FormGroup-10"
            inline={true}
            style={{ marginBottom: "0px"}}>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-12"
              width="2">
              <label
                id="CardBillingBLInterfaceUX-label-30">
                วันที่สร้าง
              </label>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-13"
              width="2">
              <label
                id="CardBillingBLInterfaceUX-label-31">
                HN
              </label>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-14"
              width="2">
              <label
                id="CardBillingBLInterfaceUX-label-32">
                Invoiceitem ID
              </label>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-15"
              width="2">
              <label
                id="CardBillingBLInterfaceUX-label-33">
                Document No
              </label>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-16"
              width="2">
              <label
                id="CardBillingBLInterfaceUX-label-34">
                Document Type
              </label>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-17"
              width="2">
              <label
                id="CardBillingBLInterfaceUX-label-35">
                {"\u00A0"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardBillingBLInterfaceUX-FormGroup-11"
            inline={true}>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-19"
              width="2">
              <div
                id="CardBillingBLInterfaceUX-div-36"
                style={{ width: "100%" }}>
                
                <DateTextBox
                  id="CardBillingBLInterfaceUX-DateTextBox-41"
                  onChange={props.onChangeDate}
                  value={props.searchBillingBL?.createdDate}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-20"
              width="2">
              <div
                id="CardBillingBLInterfaceUX-div-37"
                style={{ width: "100%" }}>
                
                <Input
                  id="CardBillingBLInterfaceUX-Input-42"
                  name="hn"
                  onChange={props.onChangeData}
                  value={props.searchBillingBL?.hn || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-21"
              width="2">
              <div
                id="CardBillingBLInterfaceUX-div-38"
                style={{ width: "100%" }}>
                
                <Input
                  id="CardBillingBLInterfaceUX-Input-43"
                  name="invoiceItemId"
                  onChange={props.onChangeData}
                  value={props.searchBillingBL?.invoiceItemId || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-22"
              width="2">
              <div
                id="CardBillingBLInterfaceUX-div-39"
                style={{ width: "100%" }}>
                
                <Input
                  id="CardBillingBLInterfaceUX-Input-44"
                  name="documentNo"
                  onChange={props.onChangeData}
                  value={props.searchBillingBL?.documentNo || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-23"
              width="2">
              <div
                id="CardBillingBLInterfaceUX-div-40"
                style={{ width: "100%" }}>
                
                <Input
                  id="CardBillingBLInterfaceUX-Input-45"
                  name="documentType"
                  onChange={props.onChangeData}
                  value={props.searchBillingBL?.documentType || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-24"
              width="2">
              <div
                id="CardBillingBLInterfaceUX-div-25"
                style={{ width: "100%", display: "flex" }}>
                
                <div
                  id="CardBillingBLInterfaceUX-div-26"
                  style={{ margin: "0px 20px" }}>
                  
                  <div
                    id="CardBillingBLInterfaceUX-div-28">
                    {props.searchButton}
                  </div>
                </div>
                <div
                  id="CardBillingBLInterfaceUX-div-27">
                  
                  <Button
                    color="orange"
                    id="CardBillingBLInterfaceUX-Button-29"
                    onClick={props.onClearFilter}>
                    Clear
                  </Button>
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardBillingBLInterfaceUX-div-2">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.billingBLInterfaceList}
            id="CardBillingBLInterfaceUX-Table-4"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardBillingBLInterfaceUX-div-3"
          style={{ marginTop: "20px" }}>
          
          <FormGroup
            id="CardBillingBLInterfaceUX-FormGroup-5"
            inline={true}
            style={{ justifyContent: "flex-end" }}>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-6">
              <div
                id="CardBillingBLInterfaceUX-div-8">
                {props.addButton}
              </div>
            </FormField>
            <FormField
              id="CardBillingBLInterfaceUX-FormField-7">
              <div
                id="CardBillingBLInterfaceUX-div-9">
                {props.editButton}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardBillingBLInterfaceUX

export const screenPropsDefault = {}

/* Date Time : Wed Apr 30 2025 16:10:46 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(-180px + 100vw)\", height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"20px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.billingBLInterfaceList"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-Table-4"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ justifyContent: \"flex-end\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.addButton"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editButton"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormGroup-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"0px\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormGroup-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-12"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-13"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-14"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-15"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-16"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-17"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-19"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-20"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-21"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-22"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-23"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-FormField-24"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\" }"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-27"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-28"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Button",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-Button-29"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClearFilter"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สร้าง"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-label-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-label-31"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "Invoiceitem ID"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-label-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "Document No"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-label-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "label",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "Document Type"
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-label-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-label-35"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 41,
      "name": "DateTextBox",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-DateTextBox-41"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingBL?.createdDate"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Input",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-Input-42"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingBL?.hn || \"\""
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Input",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-Input-43"
        },
        "name": {
          "type": "value",
          "value": "invoiceItemId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingBL?.invoiceItemId || \"\""
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Input",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-Input-44"
        },
        "name": {
          "type": "value",
          "value": "documentNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingBL?.documentNo || \"\""
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "Input",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingBLInterfaceUX-Input-45"
        },
        "name": {
          "type": "value",
          "value": "documentType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingBL?.documentType || \"\""
        }
      },
      "seq": 45,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardBillingBLInterfaceUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
